export const EVOLUTION_TYPE = {
	USERS: 'User',
	SECTIONS: 'Section',
	COUNTRY: 'Country',
}

export const SPECIAL_COUNTRIES = {
	HQ: 'HQ',
	EMAD: 'EMAD',
	ALL: 'ALL',
	LATAM: 'LATAM',
	PENHHQ: 'PENH-HQ',
	EMIRATES: 'EMIRATES',
	APAC: 'APAC',
}

export const TABS_TOP = {
	MARKETS: 'countries',
	USERS: 'users',
	DASHBOARD: 'dashboards',
	CUSTOMERS: 'customers'
}

export const LIST_SPECIAL_COUNTRIES = [SPECIAL_COUNTRIES.HQ, SPECIAL_COUNTRIES.EMAD, SPECIAL_COUNTRIES.ALL, SPECIAL_COUNTRIES.LATAM, 
	SPECIAL_COUNTRIES.PENHHQ, SPECIAL_COUNTRIES.EMIRATES, SPECIAL_COUNTRIES.APAC]